<template>
<!--  <div class="right-section">-->
<!--    <div class="login-form-container">-->
<!--      <div class="logo-container-copy"><img src="@/assets/images/Logo.svg" loading="lazy" alt="" class="logo"></div>-->
<!--      <div class="login-header">-->
<!--        <h1 class="heading-20">Reset your password</h1>-->
<!--      </div>-->
<!--      <forget-password-form/>-->
<!--      <div class="sign-up-block">-->
<!--        <router-link to="/logon" class="link-block-6 w-inline-block">-->
<!--          <div class="text-block-22">Already a Member? <span class="text-span-3">Login</span></div>-->
<!--        </router-link>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div>
    <home-layout  v-if="auth.forgetPasswordScreen === 'email'">
      <main class="main-wrapper" style="background-color: #FFFFFF">
        <div class="section">
          <div class="wrapper" style="display: grid">
            <div id="w-node-_87bd402b-7670-11cd-2caa-9c5a6de2e5dd-3b72a90b" class="col is-image" style="height: 100%">
              <div class="image_wrapper"></div>
            </div>
            <div id="w-node-ccead28d-c7cd-0dbc-2ebe-872781b23751-a5d4fc08" class="col right">
              <div class="block">
                <a href="#" class="logo__block"><img src="../../../public/images/Apvertise-logo.svg" loading="lazy" alt=""></a>
                <div class="message__block">
                  <h3 class="form__heading">Did you forget your password?</h3>
                  <p class="form__p" style="font-size: 15px; font-weight: 300">We’re sorry about that! Let’s help you recover your password</p>
                </div>
                <div class="form__block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form" @submit.prevent="initiateForgetPassword">
                    <div class="form__item"><label for="First-Name-2" class="form__label">Email</label>
                      <div class="input"><input type="email" class="form__input" maxlength="256" name="Email" data-name="Email" placeholder="name@someone.com" id="Email" required v-model="model.username" style="width: 100%;"><img src="../../../public/images/mail.svg" loading="lazy" alt="" class="form__input-icon"></div>
                    </div>
                    <div v-if="auth.authLoading" class="btn__submit w-button">
                      <b-spinner
                        small
                        style="color: #fff"
                      />
                    </div>
                    <input type="submit" value="Proceed" data-wait="Please wait..." class="btn__submit w-button" v-else>
                  </form>
                  <div class="login__block">Go back to log in?<a href="#" class="login__link" @click="goToLogin">Login</a>
                  </div>
                  <div class="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </home-layout>
    <home-layout v-if="auth.forgetPasswordScreen === 'otp'">
      <main class="main-wrapper">
        <div class="section">
          <div class="wrapper" style="display:grid;">
            <div id="w-node-_87bd402b-7670-11cd-2caa-9c5a6de2e5dd-3b72a90b" class="col is-image" style="height: 100%">
              <div class="image_wrapper"></div>
            </div>
            <div id="w-node-ccead28d-c7cd-0dbc-2ebe-872781b23751-67120eb4" class="col right">
              <div class="block">
                <a href="#" class="logo__block w-inline-block"><img src="../../../public/images/Apvertise-logo.svg" loading="lazy" alt=""></a>
                <div class="message__block">
                  <h3 class="form__heading">Hello, you’ve got mail!</h3>
                  <p class="form__p" style="font-size: 15px; font-weight: 300">A mail has been sent to you for verification. Please provide the 6 digit code sent to your email to proceed.</p>
                </div>
                <div class="form__block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form" @submit.prevent="goToPassword">
                    <div class="code__grid">
                      <v-otp-input
                        ref="otpInput"
                        input-classes="code__input"
                        separator=""
                        :num-inputs="6"
                        :should-auto-focus="true"
                        :is-input-num="true"
                        :length="6"
                        v-model="model2.otp"
                        @on-change="handleOnChange"
                        @on-complete="handleOnComplete"
                      />
                    </div>
                    <div v-if="auth.authLoading" class="btn__submit w-button">
                      <b-spinner
                        small
                        style="color: white"
                      />
                    </div>
                    <input type="submit" value="Verify Email" data-wait="Please wait..." class="btn__submit w-button" v-else>
                  </form>
                  <div class="login__block">Didn&#x27;t get the code?<a href="#" class="login__link" @click="sendOtp"><span v-if="auth.authLoading"></span><span v-else>Resend OTP</span></a>
                  </div>
                  <div class="w-form-done"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </home-layout>
    <home-layout v-if="auth.forgetPasswordScreen === 'password'">
      <main class="main-wrapper">
        <div class="section">
          <div class="wrapper" style="display: grid">
            <div id="w-node-_87bd402b-7670-11cd-2caa-9c5a6de2e5dd-1cccdc28" class="col is-image" style="height: 100%">
              <div class="image_wrapper"></div>
            </div>
            <div id="w-node-ccead28d-c7cd-0dbc-2ebe-872781b23751-1cccdc28" class="col right">
              <div class="block">
                <a href="#" class="logo__block w-inline-block"><img src="../../../public/images/Apvertise-logo.svg" loading="lazy" alt=""></a>
                <div class="message__block">
                  <h3 class="form__heading">Create a new password</h3>
                  <p class="form__p">We’re sorry about that! Let’s help you recover your password</p>
                </div>
                <div class="form__block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form" @submit.prevent="completeForgetPassword">
                    <div class="form__item"><label for="First-Name-2" class="form__label">New Password</label>
                      <div class="input"><input type="password" class="form__input w-input" name="Password" data-name="Password" placeholder="password" id="password" required v-model="model2.password" minlength="6" maxlength="6" @keypress="this.isNumber"><img src="../../../public/images/lock.svg" loading="lazy" alt="" class="form__input-icon lock"></div>
                    </div>
                    <div class="form__item"><label for="First-Name" class="form__label">Confirm New Password</label>
                      <div class="input"><input type="password" class="form__input w-input" name="Password-2" data-name="Password 2" placeholder="password" id="confirm_password" required v-model="model2.passwordConfirmation" minlength="6" maxlength="6" @keypress="this.isNumber" @change="validatePassword"><img src="../../../public/images/lock.svg" loading="lazy" alt="" class="form__input-icon lock"></div>
                    </div>
                    <div v-if="auth.authLoading" class="btn__submit w-button">
                      <b-spinner
                        small
                        style="color: #fff"
                      />
                    </div>
                    <input type="submit" value="Proceed" data-wait="Please wait..." class="btn__submit w-button" v-else>
                  </form>
                  <div class="login__block">Go back to log in?<a href="#" class="login__link" @click="goToLogin">Login</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </home-layout>
  </div>

</template>

<script>
// import ForgetPasswordForm from "@/components/form/ForgetPasswordForm";
import HomeLayout from "@/views/layout/HomeLayout.vue";
import AuthRequest from "@/model/request/AuthRequest";
import { mapState } from "vuex";

export default {
  name: "ForgetPassword",
  components:{
    HomeLayout
  },
  data() {
    return {
      model: AuthRequest.prototype.initiateResetPassword(), //new AuthRequest().logon(),
      model2: AuthRequest.prototype.completeResetPassword(),
      timer: "2:00",
      timerCount: 0,
    };
  },
  methods: {
    validatePassword() {
      let password = document.getElementById("password");
      let confirm_password = document.getElementById("confirm_password");
      if(password.value !== confirm_password.value) {
        confirm_password.setCustomValidity("Passwords Don't Match");
      } else {
        confirm_password.setCustomValidity('');
      }
    },
    handleOnComplete(value) {
      console.log('OTP completed: ', value);
      localStorage.setItem("otp", value)
      this.$store.commit("auth/updateForgetPasswordScreen", "password");
    },
    handleOnChange(value) {
      console.log('OTP changed: ', value);
    },
    initiateForgetPassword() {
      this.$store.dispatch("auth/initiateResetPassword", this.model);
      this.timerCount = 10;
    },
    goToPassword(){
      this.$store.commit("auth/updateForgetPasswordScreen", "password");
    },
    completeForgetPassword() {
      this.model2.otp = localStorage.getItem("otp")
      this.model2.username = this.model.username;
      this.model2.countryCode = this.model.countryCode;
      this.$store.dispatch("auth/completeResetPassword", this.model2);
    },
    isNumber(event) {
      if (!/\d/.test(event.key) && event.key !== ".")
        return event.preventDefault();
    },
    startTimer(duration) {
      let timer = duration,
        minutes,
        seconds;
      setInterval(function () {
        minutes = parseInt((timer / 60).toString(), 10);
        seconds = parseInt((timer % 60).toString(), 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.timer = minutes + ":" + seconds;
        if (--timer < 0) {
          timer = duration;
        }
      }, 1000);
    },
    sendOtp() {
      this.$store
        .dispatch("auth/resendOtpInApp", {
          phoneNumber: this.model.username,
          countryCode: "234",
        })
        .then(() => {
          console.log("Timer...");
          this.timerCount = 10;
        });
    },
    goToLogin(){
      this.$router.push("/logon")
    },
  },
  computed: {
    ...mapState(["auth"]),
  },
  created() {
    this.$store.commit("auth/updateForgetPasswordScreen", "email");
    const eye = document.querySelector(".lock");
    const passwordField = document.querySelector("input[type=password]");

    eye.addEventListener("click", () => {
      if (passwordField.type === "password"){
        passwordField.type = "text";
      } else {
        passwordField.type = "password";
      }
    });
  },
};
</script>

<style scoped>
.section{
  margin: 0;
}
.wrapper{
  background: #FFFFFF !important;
}
h1, h2, h3, h4, h5, h6, p{
  margin: 0;
}

.w-input{
  padding: 10px 14px 10px 48px;
  margin: 0;
  height: 44px;
  border-style: solid;
  border-width: 1px;
  border-color: #d0d5dd;
  border-radius: 50rem;
  background-color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 0.875rem;
  line-height: 1.7142857142857142;
  font-weight: 500;
}

.code__input{
  margin-right: 16px;
}

.w-input::placeholder{
  color: rgba(52, 64, 84, 0.6);
}

.btn__submit {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 44px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50rem;
  background-color: #489e85;
  font-family: Figtree, sans-serif;
  font-weight: 600;
  cursor: pointer;
}

.login__link{
  font-weight: 500;
}

</style>